import { DateUtilsService } from '../services/date-utils.service';
import { TranslateService } from '@ngx-translate/core';
import { HttpClient, HttpHeaders } from '@angular/common/http'
import { blobToBase64 } from '../utils'
import { Animal } from './animal';
import { ComptaService } from '../services/compta.service';
import { PharmacyProduct } from './pharmacy';

export class ComptaInvoiceLine {
    id: number | null = null;
    amount: number = 0;
    description: string = '';
    animals: Animal[] = [];
}

export class ComptaInvoice {
    id: number | null = null;
    userId: number| null = null;
    date: string | null = null;
    description: string = '';
    amount: number = 0;
    file: string | null = null;
    fileNewName: string | null = null;
    fileBase64: string | null = null;
    lines: ComptaInvoiceLine[] = [];

    eventId: number | null = null;
    eventName: string | null = null;
    eventDate: string | null = null;

    pharmacyProducts: PharmacyProduct[] = [];

    linesOfAnimal(animal: Animal[]) {
        return this.lines.filter(l => l.animals.filter(a => animal.map(a => a.id).includes(a.id)).length >0)
    }
}
